import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { BaseWebService } from './../../services/base-web.service';

@Injectable()
export class LtrErrorPopupService {
    constructor(
        private _baseWebService: BaseWebService
    ) {
    }

    /**
     * Function to get patient file history from api.
     * @param  {any} id contains patient id.
     */
    revisePlan(id: any) {
        const data: any = {};
        data.body = {};
        return this._baseWebService.request("v1/treatment_plan/" + id + "/revise/", "put", data)
            .map(res => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}
